// time-picker.component.ts
import { Component, effect, Input, input, output, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-time-picker',
  standalone: true,
  imports: [MaterialModule, ReactiveFormsModule],
  templateUrl: './time-picker.component.html',
  styleUrl: './time-picker.component.scss'
})
export class TimePickerComponent {
  @ViewChild('timeDropdown') timeDropdown!: MatSelect;
  defualtValue= input<Date>() ; 
  label = input<string>('Time');
  valueChange = output<string>() 
  cleared = output<void>() // Add this new output
  timeOptions: string[] = []; 
  value: string = '';
  focusTime = input<any>();
  @Input() control!: FormControl;
  readOnlyPicker = input<boolean>(false);
  showDefaultTime = input<boolean>(false);
  hideClearButton = input<boolean>(false);

  constructor(){
    effect(() => {
      if(this.defualtValue()){
        this.value = this.formatTime(this.defualtValue());
        
        this.control.setValue(this.value);
      }
      
      // Set default time if showDefaultTime is true and control has no value
      if (this.showDefaultTime() && !this.control.value && this.focusTime()) {
        this.value = this.focusTime();
        this.control.setValue(this.value);
        this.valueChange.emit(this.value);
      }

      // if (this.readOnlyPicker()) {
      //   this.control.disable({ emitEvent: false });
      // } else {
      //   this.control.enable({ emitEvent: false });
      // }
      
    });
  }

  ngOnInit(): void {
    this.generateTimeOptions();
    if (!this.control) {
      this.control = new FormControl('');
    }
    
    // Subscribe to control value changes to keep internal value in sync
    
  }

  openDropdown(): void {
    if (this.readOnlyPicker()) {        
      return;
    }
    if(!this.control.value && this.focusTime()){
      this.value = this.focusTime()
      this.control.setValue(this.value);
    }
    this.timeDropdown.open();
    // this.scrollToSelectedTime()
  }

  // Generate time options in 15-minute intervals
  generateTimeOptions() {
    const times = [];
    for (let i = 0; i < 24 * 60; i += 15) {
      const hours = Math.floor(i / 60);
      const minutes = i % 60;
      const time = new Date(0, 0, 0, hours, minutes);
      times.push(this.formatTime(time));
    }
    this.timeOptions = times;
  }

  // Format time as hh:mm AM/PM
  formatTime(time: Date): string {
    const hours = time.getHours();
    const minutes = time.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  }

  // Handle time changes (manual input or dropdown selection)
  onTimeChange(event: any): void {
    if (this.readOnlyPicker()) { 
      return;
    }
    const newValue = event.value || event.target.value;
    
    if (event.value !== undefined) {
      // From dropdown
      const isValidTime = /^(\d{1,2}):(\d{2})\s?(AM|PM)$/i.test(newValue);
      if (isValidTime) {
        this.control.setValue(newValue);
        // mat-select uses [value] (not [formControl]) so the directive can't
        // mark dirty/touched for us — do it here so the parent form's Save
        // button enables on a time-only change.
        this.control.markAsDirty();
        this.control.markAsTouched();
        this.valueChange.emit(newValue);
      }
    } else {
      // From input
      this.control.setValue(newValue, { emitEvent: false });

      const isValidTime = /^(\d{1,2}):(\d{2})\s?(AM|PM)$/i.test(newValue);
      if (isValidTime) {
        this.valueChange.emit(newValue);
      }
    }
  }

  // Clear the time value
  clearTime(event: Event): void {
    event.stopPropagation(); // Prevent dropdown from opening
    this.value = '';
    this.control.setValue('');
    this.control.markAsDirty();
    this.control.markAsTouched();
    this.valueChange.emit(''); // Emit empty value
    this.cleared.emit(); // Emit cleared event
  }

  scrollToSelectedTime(): void {
    if (this.timeDropdown && this.control.value) {
      const selectedTime = this.control.value;
      const selectedOption = this.timeDropdown.options.find(
        (option) => option.value === selectedTime
      );

      if (selectedOption) {
        setTimeout(() => {
          selectedOption._getHostElement().scrollIntoView({
            behavior: 'auto',
            block: 'start',
          });
        }, 0);
      }
    }
  }

  ngAfterViewInit(): void {
    this.timeDropdown.openedChange.subscribe((isOpened) => {
      if (isOpened) {
        this.scrollToSelectedTime();
      }
    });
  }
}